<template>
  <!-- Error Notification -->
  <div
    v-if="
      productErrors ||
      componentErrors ||
      categoryErrors ||
      hardRefreshErrors ||
      blogErrors
    "
    class="px-6 py-4 border-0 rounded-t-md bg-red-500 text-white"
  >
    <div class="flex items-center justify-between flex-wrap">
      <div class="flex flex-col">
        <div
          v-if="
            productErrors ||
            componentErrors ||
            categoryErrors ||
            hardRefreshErrors ||
            blogErrors
          "
          class="font-medium text-white truncate"
        >
          <i class="fas fa-exclamation-circle"></i>
          {{
            productErrors ||
            componentErrors ||
            categoryErrors ||
            hardRefreshErrors ||
            blogErrors
          }}
        </div>
      </div>
      <button
        @click="close"
        type="button"
        class="rounded-md hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-white"
      >
        <span class="sr-only">Dismiss</span>
        <!-- Heroicon name: outline/x -->
        <svg
          class="h-6 w-6 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  </div>
  <!-- Success Notification -->
  <div
    v-if="
      hardRefreshSuccess || componentSuccess || categorySuccess || blogSuccess
    "
    class="px-6 py-4 border-0 rounded-t-md bg-green-500 text-white"
  >
    <div class="flex items-center justify-between flex-wrap">
      <div class="flex flex-col">
        <div
          v-if="
            hardRefreshSuccess ||
            componentSuccess ||
            categorySuccess ||
            blogSuccess
          "
          class="font-medium text-white truncate"
        >
          <i class="fas fa-exclamation-circle"></i>
          {{
            hardRefreshSuccess ||
            componentSuccess ||
            categorySuccess ||
            blogSuccess
          }}
        </div>
      </div>
      <button
        @click="close"
        type="button"
        class="rounded-md hover:bg-green-400 focus:outline-none focus:ring-2 focus:ring-white"
      >
        <span class="sr-only">Dismiss</span>
        <!-- Heroicon name: outline/x -->
        <svg
          class="h-6 w-6 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";

export default {
  name: "BannerNotification",
  computed: {
    ...mapGetters([
      "productErrors",
      "componentErrors",
      "categoryErrors",
      "hardRefreshErrors",
      "blogErrors",
      "hardRefreshSuccess",
      "componentSuccess",
      "categorySuccess",
      "blogSuccess"
    ])
  },
  methods: {
    close() {
      // Errors
      if (this.productErrors)
        this.$store.dispatch(Actions.CLEAR_PRODUCT_ERRORS);
      if (this.componentErrors)
        this.$store.dispatch(Actions.CLEAR_COMPONENT_ERRORS);
      if (this.categoryErrors)
        this.$store.dispatch(Actions.CLEAR_CATEGORY_ERRORS);
      if (this.hardRefreshErrors)
        this.$store.dispatch(Actions.CLEAR_HARDREFRESH_ERRORS);
      if (this.blogErrors) this.$store.dispatch(Actions.CLEAR_BLOG_ERRORS);
      // Success
      if (this.hardRefreshSuccess)
        this.$store.dispatch(Actions.CLEAR_HARDREFRESH_SUCCESS);
      if (this.componentSuccess)
        this.$store.dispatch(Actions.CLEAR_COMPONENT_SUCCESS);
      if (this.categorySuccess)
        this.$store.dispatch(Actions.CLEAR_CATEGORY_SUCCESS);
      if (this.blogSuccess) this.$store.dispatch(Actions.CLEAR_BLOG_SUCCESS);
    }
  }
};
</script>
